// extracted by mini-css-extract-plugin
module.exports = {"root":"AppHeader_root__wLpC3","divider":"AppHeader_divider__19JMB","dividerInner":"AppHeader_dividerInner__2pibu"};